import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"castle-4"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 9C14.7614 9 17 11.2386 17 14V21H7V14C7 11.2386 9.23858 9 12 9Z"}},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M21 21V3H15V10C16.2142 10.9122 17 12.3644 17 14V21H21Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M3 21H7V14C7 12.3643 7.78565 10.9122 9 10V3H3V21Z"}}]},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 20.9999V18.3428M3 21H7V14C7 12.3643 7.78565 10.9122 9 10V3H3V21ZM21 3V21H17V14C17 12.3644 16.2142 10.9122 15 10V3H21Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M17 14.8V21H7V14.8M12 9C14.7614 9 17 11.2386 17 14H7C7 11.2386 9.23858 9 12 9ZM12 9V8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Castle4 = Vue.extend<IconProps>({
  name: 'Castle4Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'castle-4',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Castle4;
